import { eventConfig } from './events';

const config = {
  lang: 'en',
  debug: false,
  urlPrefixBare: 'https://aanmelden.briard.nl',
  recaptchaSiteKey: '6Lfr2VAUAAAAAMWpslZQb1PeQJnwcgnJ62HATsjP',
  ...eventConfig,
};

const isDevelopmentMode = window.location.href.includes(':8080/');
if (isDevelopmentMode) {
  config.urlPrefixBare = 'https://briard.test';
} else {
  config.debug = false;
}

// todo: allow these settings to be set on the fly.
// todo: only strip local url of port numbers if needed.
if (config.debug) {
  config.urlPrefix = `${config.urlPrefixBare}/frontend_dev.php/${config.lang}`;
} else {
  config.urlPrefix = `${config.urlPrefixBare}/${config.lang}`;
}
export default config;



// WEBPACK FOOTER //
// ./src/config.js